import {ActivatedRouteSnapshot} from '@angular/router';
import {RouteOption} from './route-option';

export abstract class NumberRouteOption extends RouteOption<number> {
	protected constructor(
		key: string,
		route: ActivatedRouteSnapshot,
		values: Set<number>,
		defaultValue: number,
	) {
		super(
			key,
			route,
			values,
			defaultValue
		);
	}

	toValue(value?: string): number | undefined {
		const numberValue = Number.parseInt(value ?? '', 10);
		return !isNaN(numberValue) ? numberValue : undefined;
	}

	toString(value: number): string {
		return value.toString();
	}
}
